/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
author: Karis (https://sketchfab.com/squgily3d)
license: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
source: https://sketchfab.com/3d-models/cute-cat-model-62b9adea5c7b4e31bb016a902b07fe5c
title: Cute Cat Model
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Cat({ ...props }) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/cat.gltf')
  
  return (
    <group ref={group} {...props} dispose={null} scale={0.5} position={[-0.9, 0.3, 0.5]}>
      <group rotation={[-Math.PI / 2, 0, -Math.PI ]}>

        <mesh geometry={nodes.Object_7.geometry} material={materials.material_5} />
        <mesh geometry={nodes.Object_9.geometry} material={materials.material_4} />
        <mesh geometry={nodes.Object_11.geometry} material={nodes.Object_11.material} />
        <mesh geometry={nodes.Object_12.geometry} material={nodes.Object_12.material} />
        <mesh geometry={nodes.Object_14.geometry} material={materials.material_2} />
        <mesh geometry={nodes.Object_16.geometry} material={materials.material_1} />
        <mesh geometry={nodes.Object_18.geometry} material={materials.material_0} />
      </group>
    </group>
  )
}

useGLTF.preload('/cat.gltf')
